// components/HamburgerMenu.js
// App navigation header and slide-out drawer
// Commercial use: original IP

import React, { useState } from "react";
import { NAVY, BLUE, RED, STEEL, MUTED, BORDER, BRAND_NAME } from "../constants";

export default function HamburgerMenu({ isAdmin, role, onSignOut, onNav, tab }) {
  const [open, setOpen] = useState(false);

  const residentNav = [
    ["home",           "Home"],
    ["schedule",       "Book a Pickup"],
    ["requests",       "My Requests"],
    ["referral",       "Invite a Neighbor"],
    ["pickupschedule", "Pickup Schedule"],
    ["privacydata",    "Privacy and Data"],
    ["deleteaccount",   "Delete Account"],
    ["pricing",        "Pricing"],
    ["faq",            "FAQ"],
    ["legal",          "Terms and Policies"],
  ];

  const adminNav = [
    ["home",          "Home"],
    ["admin",         "Operations"],
    ["drivers",       "Hauler Management"],
    ["revenue",       "Revenue"],
    ["community_alerts", "Community Alerts"],
    ["operator",      "Waitlist Ops"],
    ["legal",         "Terms and Policies"],
  ];

  const navItems = isAdmin ? adminNav : residentNav;

  return (
    <>
      <div style={{ background: NAVY, minHeight: 74, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 20px", paddingTop: "env(safe-area-inset-top, 0px)", position: "sticky", top: 0, zIndex: 100 }}>
        <img src="/LoadDashLLC.png" alt={BRAND_NAME} style={{ height: 32, maxWidth: "100%", objectFit: "contain" }} />
        <button onClick={() => setOpen(true)} aria-label="Open navigation menu" style={{ background: "rgba(255,255,255,.1)", border: "none", borderRadius: 8, padding: "10px 12px", cursor: "pointer", display: "flex", flexDirection: "column", gap: 4, minWidth: 44, minHeight: 44, alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: 18, height: 2, background: "#fff", borderRadius: 1 }} />
          <div style={{ width: 18, height: 2, background: "#fff", borderRadius: 1 }} />
          <div style={{ width: 18, height: 2, background: "#fff", borderRadius: 1 }} />
        </button>
      </div>

      {open && <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 200 }} />}

      {open && (
        <div role="dialog" aria-modal="true" aria-label="Navigation menu" style={{ position: "fixed", top: 0, right: "max(0px,calc((100vw - 480px)/2))", bottom: 0, width: 260, background: "#fff", zIndex: 201, display: "flex", flexDirection: "column", boxShadow: "-4px 0 24px rgba(0,0,0,.15)" }}>
          <div style={{ background: NAVY, padding: "18px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <img src="/LoadDashLLC.png" alt={BRAND_NAME} style={{ height: 24, maxWidth: "100%", objectFit: "contain" }} />
            <button onClick={() => setOpen(false)} aria-label="Close navigation menu" style={{ background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer", lineHeight: 1, minWidth: 44, minHeight: 44, display: "flex", alignItems: "center", justifyContent: "center" }}>x</button>
          </div>

          <div style={{ flex: 1, overflowY: "auto", padding: "12px 0" }}>
            {navItems.map(([t, label]) => {
              const isDelete = t === "deleteaccount";
              return (
              <div key={t} onClick={() => { onNav(t); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 20px", cursor: "pointer", background: tab === t ? "#edf4ff" : "transparent", borderLeft: tab === t ? `3px solid ${BLUE}` : "3px solid transparent", minHeight: 44 }}>
                <span style={{ fontSize: 15, fontWeight: tab === t ? 700 : 500, color: isDelete ? RED : tab === t ? BLUE : NAVY }}>{label}</span>
              </div>
            );})}
          </div>

          {isAdmin && (
            <div style={{ padding: "12px 20px", borderTop: `1px solid ${BORDER}` }}>
              <span style={{ fontSize: 10, color: MUTED, border: `1px solid ${BORDER}`, padding: "3px 8px", borderRadius: 4, textTransform: "uppercase", letterSpacing: 1, fontWeight: 700 }}>Admin</span>
            </div>
          )}

          <div style={{ padding: "16px 20px", borderTop: `1px solid ${BORDER}` }}>
            <button onClick={() => { onSignOut(); setOpen(false); }} style={{ width: "100%", padding: "12px", borderRadius: 10, border: `1.5px solid ${BORDER}`, background: "#fff", color: RED, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>Sign Out</button>
          </div>
        </div>
      )}
    </>
  );
}
